import styled from "styled-components";
import { Phone, AppleAlt } from "../../styles/Icons";
import BannerImg from "../../assets/svg/banner.svg";

export const Container = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  width: 100%;
  height: 100%;

  @media only screen and (max-width: 575px) {
    overflow-y: scroll;
  }
`;

export const BannerContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-image: url(${BannerImg});
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 0.6rem;
  padding: 2rem;
  width: 100%;
  margin-bottom: 1.5%;

  @media only screen and (max-width: 768px) {
    flex-direction: column;
    gap: 2rem;
    text-align: center;
  }
`;

export const BannerContent = styled.div`
  h2 {
    color: white;
    font-weight: bold;
    margin-bottom: 4px;
  }

  h1 {
    color: white;
    font-size: 2.6rem;
    font-weight: 700;
    margin-bottom: 12px;
  }

  p {
    color: white;
    font-size: 1.1rem;
    font-weight: 300;
    max-width: 450px;
  }

  .buttons {
    display: flex;
    gap: 1rem;
    margin-top: 1.5rem;
    font-size: 1.2rem;

    button {
      height: 2.5rem;
      padding: 0 20px;
      font-weight: bold;
      display: flex;
      align-items: center;
      gap: 8px;
      border: none !important;

      &.btn-android {
        background-color: var(--orange-250) !important;
        color: var(--white);
        border-radius: 0.6rem;

        :hover {
          color: var(--white) !important;
        }
      }

      &.btn-ios {
        border-radius: 0.6rem;
        color: var(--black-opaco) !important;
        background: var(--white);

        :hover {
          color: var(--black-opaco) !important;
        }
      }
    }
  }
`;

export const CardContainer = styled.div`
  display: flex;
  width: 100%;
  height: 75%;

  @media only screen and (max-width: 575px) {
    height: 70%;
  }
`;

export const Cards = styled.div`
  ::-webkit-scrollbar {
    height: 0.7rem;
  }

  ::-webkit-scrollbar-track {
    background: var(--gray-500);
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb {
    background: var(--gray-550);
    border-radius: 10px;
  }

  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: 25%;
  grid-gap: 1%;
  height: 100%;
  width: 100%;

  overflow-x: auto;

  @media only screen and (max-width: 575px) {
    display: grid;
    grid-gap: 1%;
    grid-auto-flow: row;
    grid-auto-columns: none;
    grid-template-columns: repeat(1, 1fr);
    overflow-x: none;
  }
`;

export const PhoneIcon = styled(Phone)`
  width: 1.2rem;
  height: 1.2rem;
  color: var(--white);
  margin-right: 0.5rem;
`;

export const AppleIcon = styled(AppleAlt)`
  width: 1.2rem;
  height: 1.2rem;
  color: var(--black-opaco);
  margin-right: 0.5rem;
`;

export const QRModalContent = styled.div`
  p {
    font-size: 0.95rem;
    color: var(--gray-530);
    margin-bottom: 1rem;
    text-align: center;
    font-weight: 500;
  }

  .qr-wrapper {
    display: flex;
    justify-content: center;
    margin: 20px 0;

    canvas {
      padding: 10px;
      border: 3px solid var(--orange-250);
      border-radius: 12px;
      background-color: var(--white);
    }
  }

  .qr-link {
    text-align: center;
    font-size: 0.9rem;
    color: var(--gray-800);

    a {
      color: var(--orange-250);
      font-weight: 500;

      :hover {
        text-decoration: underline;
      }
    }
  }

  .btn-wrapper {
    display: flex;
    justify-content: center;
    margin-top: 16px;
  }

  button {
    height: 2.5rem;
    padding: 0 20px;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    border: none !important;

    &.btn-modal-ios {
      background-color: var(--orange-250) !important;
      color: var(--white);
      border-radius: 0.6rem;

      :hover {
        color: var(--white) !important;
      }
    }
  }
`;
